import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
import { EntityService } from "./entity-service";

export class ContactSharedDataService {

    static $inject = ["$q", "entityService"];

    contact: Models.IEntityCharDataPair;
    contactPromise: ng.IPromise<Models.IEntityCharDataPair>;

    contactStatus: Models.IEntityStatus;
    contactStatusPromise: ng.IPromise<Models.IEntityStatus>;

    constructor(private $q: ng.IQService, private entityService: EntityService) {
        this.contact = null;
        this.contactStatus = null;
    }

    RefreshFiles(contactID: string): ng.IPromise<any> {
        if (this.contactPromise == null) {
            this.contactPromise = this.entityService.getEntity(contactID);
            this.contactPromise
                .then((result) => {
                    this.contact = result;
                })
                .finally(() => {
                    this.contactPromise = null;
                });
        }
        return this.contactPromise || this.$q.when(this.contact);
    }

    RefreshAssetStatus(assetID: string): ng.IPromise<any> {
        if (this.contactStatusPromise == null) {
            this.contactStatusPromise = this.entityService.getEntityStatus(assetID);
            this.contactStatusPromise
                .then((result) => {
                    this.contactStatus = result;
                })
                .finally(() => {
                    this.contactStatusPromise = null;
                });
        }
        return this.contactStatusPromise || this.$q.when(this.contactStatus);
    }

    RefreshContact(contactID: string): ng.IPromise<any> {
        if (this.contactPromise == null) {
            this.contactPromise = this.entityService.getEntity(contactID);
            this.contactPromise
                .then((result) => {
                    this.contact = result;
                })
                .finally(() => {
                    this.contactPromise = null;
                });
        }
        return this.contactPromise || this.$q.when(this.contact);
    }

    RefreshContactStatus(contactID: string): ng.IPromise<any> {
        if (this.contactStatusPromise == null) {
            this.contactStatusPromise = this.entityService.getEntityStatus(contactID);
            this.contactStatusPromise
                .then((result) => {
                    this.contactStatus = result;
                })
                .finally(() => {
                    this.contactPromise = null;
                });
        }
        return this.contactPromise || this.$q.when(this.contactStatus);
    }
}